<template>
  <div class="reg-filter" :class="{ 'reg-watch': isRegWatch }">
    <div id="activityFilter" :class="{ compact: isCompact }">
      <div
        data-toggle="dropdown"
        class="reg-dropdown text-right cursor-pointer"
        v-if="collapsed"
        :class="{ 'hide-field': !collapsed, 'reg-watch': isRegWatch }"
        @click="showHideFilter()"
      >
        <span class="dropdown-toggle cursor vertical-align-middle">
          <img src="/static/images/icons/filter.svg" alt="filter-icon" />
          <span class="count" v-if="showFilterIcon">
            <span class="glyphicon glyphicon-ok"></span>
          </span>
          <img
            src="/static/images/icons/chevron_right.svg"
            alt="chevronright-icon"
            :class="{ 'pl-6': !isCompact }"
          />
        </span>
      </div>
      <div class="dropdown-menu dropdown-menu-left filter-ul" :class="{ 'hide-field': collapsed }">
        <div class="col-xs-12 pb-1 pl-0 pr-0 filter-text">
          <div data-toggle="dropdown" class="col-xs-1 p-0 pr-8">
            <img src="/static/images/icons/filter.svg" alt="filter-icon" class="image-size" />
          </div>
          <div class="col-xs-11 font-properties pl-0 pt-3">Filter</div>
          <div class="col-xs-1 pr-0">
            <a @click="showHideFilter(true)">
              <img
                src="/static/images/icons/chevron_right.svg"
                alt="chevronright-icon"
                class="image-size cursor-pointer left-transform cursor"
              />
            </a>
          </div>
        </div>
        <div class="col-xs-12 filter-wrapper p-0">
          <div class="col-xs-12 p-0" v-if="types.label === 'records'">
            <div
              v-if="permissions.includes('RECORDS_WITH_ATTACHMENT')"
              class="col-xs-12 item-divider p-0 cursor-pointer flex-between"
              @click="filterWithType('attachment')"
            >
              <div class="col-xs-10 p-0 font-properties font-bold pl-13">
                Records With Attachments
              </div>
              <img
                class="col-xs-2 text-right p-0 image-size"
                v-if="filterOptions.attachment"
                src="/static/images/icons/check.svg"
              />
            </div>
            <div
              v-if="permissions.includes('AFFECTED_BY_REGULATORY_ALERT')"
              class="col-xs-12 item-divider p-0 cursor-pointer flex-between"
              @click="filterWithType('regulatoryAlert')"
            >
              <div class="font-properties font-bold pl-13">Affected By Regulatory Alert</div>
              <img
                class="text-right image-size"
                v-if="filterOptions.regulatoryAlert"
                src="/static/images/icons/check.svg"
              />
            </div>
          </div>
          <div class="col-xs-12 p-0" v-for="(value, keyValue) in chevronList" :key="keyValue">
            <div
              class="col-xs-12 col-md-12 col-lg-12 item-divider p-0 cursor-pointer"
              @click="toggleSelection(`collapse${value.replaceAll(' ', '')}`, keyValue)"
              :class="{
                'hide-field':
                  (value === 'Sub Category' && !filterOptions.categories) ||
                  (types.label === 'launchpadAccounts' &&
                    value === 'Account Status' &&
                    !includeDeactivatedAccounts) ||
                  (types.label === 'launchpadUsers' &&
                    value === 'User Status' &&
                    !includeDeactivatedUsers) ||
                  (types.label === 'regWatch' &&
                    value === 'Posted Date' &&
                    !permissions.includes('REG_WTCH_REG_UPD_POSTED_DATE_FILTER')) ||
                  (types.label === 'regWatch' &&
                    value === 'Effective Date' &&
                    !permissions.includes('REG_WTCH_REG_UPD_EFFECTIVE_DATE_FILTER')) ||
                  (types.label === 'regWatch' &&
                    value === 'Country' &&
                    !permissions.includes('REG_WTCH_REG_UPD_COUNTRY_FILTER')) ||
                  (types.label === 'records' &&
                    value === 'Country' &&
                    !permissions.includes('COUNTRY_WISE_FILTER_AND_SEARCH')) ||
                  (types.label === 'records' &&
                    value === 'Expiration Date' &&
                    !permissions.includes('EXPIRATION_DATES')) ||
                  (types.label === 'records' &&
                    value === 'Approval Date' &&
                    !permissions.includes('APPROVAL_DATES_WITH_OPTIONS')) ||
                  (hideServicesForGlobalSearch && value === 'Services Registered')
              }"
            >
              <div class="col-xs-10 col-md-10 col-lg-10 p-0">
                <a
                  class="font-properties font-bold pl-13"
                  data-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExpireyDate"
                  >{{ value }}</a
                >
              </div>
              <div class="col-xs-2 text-right pr-2">
                <a v-if="!selection[keyValue]">
                  <img
                    src="/static/images/icons/chevron_down.svg"
                    alt="chevrondown-icon"
                    class="chevron-image"
                  />
                </a>
                <a v-else>
                  <img
                    src="/static/images/icons/chevron_down.svg"
                    alt="chevrondown-icon"
                    class="chevron-image transform-img"
                  />
                </a>
              </div>
            </div>
            <div
              v-if="
                [
                  'collapseDocumentDate',
                  'collapsePostedDate',
                  'collapseApprovalDate',
                  'collapseDate',
                  'collapseDateCreated'
                ].includes(`collapse${value.replaceAll(' ', '')}`)
              "
              class="col-xs-12 col-md-12 col-lg-12 collapse pr-0 item-divider"
              :class="[selection[keyValue] ? 'in' : '', `collapse${value.replaceAll(' ', '')}`]"
            >
              <!-- <div class="col-xs-12 col-md-12 col-lg-12 p-0 date-range"> -->
              <div class="col-xs-12 col-md-12 col-lg-12 p-0 date-range">
                <ul class="pl-0 mt-6">
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isLast7Days', 'commonDates')"
                    v-if="
                      (types.label === 'regWatch' &&
                        permissions.includes('REG_WTCH_REG_UPD_LAST_7_DAYS')) ||
                      types.label !== 'regWatch'
                    "
                  >
                    <div
                      class="col-xs-10 pl-0 sub-approval"
                      :class="{ 'font-bold': totalDates.commonDates.isLast7Days }"
                    >
                      Last 7 days
                    </div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.commonDates.isLast7Days">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                        alt="check-icon"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isLast30Days', 'commonDates')"
                    v-if="
                      (types.label === 'regWatch' &&
                        permissions.includes('REG_WTCH_REG_UPD_LAST_30_DAYS')) ||
                      types.label !== 'regWatch'
                    "
                  >
                    <div
                      class="col-xs-10 pl-0 sub-approval"
                      :class="{ 'font-bold': totalDates.commonDates.isLast30Days }"
                    >
                      Last 30 days
                    </div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.commonDates.isLast30Days">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                        alt="check-icon"
                      />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isLastYear', 'commonDates')"
                    v-if="
                      (types.label === 'regWatch' &&
                        permissions.includes('REG_WTCH_REG_UPD_LAST_YEAR')) ||
                      types.label !== 'regWatch'
                    "
                  >
                    <div
                      class="col-xs-10 pl-0 sub-approval"
                      :class="{ 'font-bold': totalDates.commonDates.isLastYear }"
                    >
                      Within last year
                    </div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.commonDates.isLastYear">
                      <img
                        src="/static/images/icons/check.svg"
                        class="image-size"
                        alt="check-icon"
                      />
                    </a>
                  </li>
                </ul>
                <filter-date
                  v-if="
                    (types.label === 'regWatch' &&
                      permissions.includes('REG_WTCH_REG_UPD_POSTED_DATE_RANGE')) ||
                    types.label !== 'regWatch'
                  "
                  :eventType="'commonDates'"
                  @dateRange="setCustomDateRange($event, value, 'commonDates')"
                  :label="types.label"
                  :dateFormat="dateFormat"
                >
                </filter-date>
              </div>
              <!-- </div> -->
            </div>
            <!-- Account types will start here -->
            <div
              v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseAccountType'"
              class="collapse collapseAccountType col-xs-12 col-md-12 col-lg-12 p-0 item-divider"
              :class="{ in: selection[keyValue] }"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 pr-0 date-range">
                <ul class="pl-0">
                  <li
                    class="col-xs-12 p-0 sub-approval"
                    @click="onAccountTypeOrStatusSelection('rep', 'accountType')"
                  >
                    <div
                      class="col-xs-10 pl-0"
                      :class="{ 'font-bold': filterOptions.accountType === 'rep' }"
                    >
                      Rep
                    </div>
                    <a class="col-xs-2 p-0 text-right" v-if="filterOptions.accountType === 'rep'">
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0 sub-approval"
                    @click="onAccountTypeOrStatusSelection('commercial', 'accountType')"
                  >
                    <div
                      class="col-xs-10 pl-0"
                      :class="{ 'font-bold': filterOptions.accountType === 'commercial' }"
                    >
                      Commercial
                    </div>
                    <a
                      class="col-xs-2 p-0 text-right"
                      v-if="filterOptions.accountType === 'commercial'"
                    >
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                  <li
                    v-if="types.label === 'launchpadUsers'"
                    class="col-xs-12 p-0 sub-approval"
                    @click="onAccountTypeOrStatusSelection('repcommercial', 'accountType')"
                  >
                    <div
                      class="col-xs-10 pl-0"
                      :class="{ 'font-bold': filterOptions.accountType === 'repcommercial' }"
                    >
                      Rep/Commercial
                    </div>
                    <a
                      class="col-xs-2 p-0 text-right"
                      v-if="filterOptions.accountType === 'repcommercial'"
                    >
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Account types will end here -->
            <!-- Confirm status for users will start here -->
            <div
              v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseConfirmStatus'"
              class="collapse collapseAccountType col-xs-12 col-md-12 col-lg-12 p-0"
              :class="{
                in: selection[keyValue],
                'item-divider': includeDeactivatedUsers,
                'mt-7': !includeDeactivatedUsers
              }"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 pr-0 date-range">
                <ul class="pl-0">
                  <li
                    class="col-xs-12 p-0 sub-approval"
                    @click="onAccountTypeOrStatusSelection('confirmed', 'confirmedType')"
                  >
                    <div
                      class="col-xs-10 pl-0"
                      :class="{ 'font-bold': filterOptions.confirmedType === 'confirmed' }"
                    >
                      Confirmed
                    </div>
                    <a
                      class="col-xs-2 p-0 text-right"
                      v-if="filterOptions.confirmedType === 'confirmed'"
                    >
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0 font-16"
                    @click="onAccountTypeOrStatusSelection('unconfirmed', 'confirmedType')"
                  >
                    <div
                      class="col-xs-10 pl-0"
                      :class="{ 'font-bold': filterOptions.confirmedType === 'unconfirmed' }"
                    >
                      Unconfirmed
                    </div>
                    <a
                      class="col-xs-2 p-0 text-right"
                      v-if="filterOptions.confirmedType === 'unconfirmed'"
                    >
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Confirm status for users will end here -->
            <!-- <div v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseUserStatus'"
              class="collapse collapseAccountType col-xs-12 col-md-12 col-lg-12 p-0 mt-7"
            >
            </div> -->

            <div
              class="collapse collapseDateSigned col-xs-12 col-md-12 col-lg-12 p-0 item-divider"
              v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseDateSigned'"
              :class="{ in: selection[keyValue] }"
            >
              <filter-date
                :eventType="'signedDates'"
                @dateRange="setCustomDateRange($event, value, 'commonDates')"
                :label="types.label"
                :dateFormat="dateFormat"
              >
              </filter-date>
            </div>

            <!-- Service Expiration will start here -->
            <div
              v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseServiceExpiration'"
              class="collapse collapseServiceExpiration col-xs-12 col-md-12 col-lg-12 p-0 item-divider"
              :class="{ in: selection[keyValue] }"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 date-range">
                <ul class="pl-0 mt-6">
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isExpiringIn30Days', 'serviceExpDates')"
                  >
                    <div
                      class="col-xs-10 pl-0 sub-approval"
                      :class="{ 'font-bold': totalDates.serviceExpDates.isExpiringIn30Days }"
                    >
                      Expiring in 30 days
                    </div>
                    <a
                      class="col-xs-2 p-0 text-right"
                      v-if="totalDates.serviceExpDates.isExpiringIn30Days"
                    >
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isExpiringIn30To45Days', 'serviceExpDates')"
                  >
                    <div
                      class="col-xs-10 pl-0 sub-approval"
                      :class="{ 'font-bold': totalDates.serviceExpDates.isExpiringIn30To45Days }"
                    >
                      Expiring &gt; 30 days and <br />
                      &le; 45 days
                    </div>
                    <a
                      class="col-xs-2 p-0 text-right"
                      v-if="totalDates.serviceExpDates.isExpiringIn30To45Days"
                    >
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                </ul>
                <filter-date
                  :eventType="'serviceExpDates'"
                  @dateRange="setCustomDateRange($event, value, 'serviceExpDates')"
                  :label="types.label"
                  :dateFormat="dateFormat"
                >
                </filter-date>
              </div>
            </div>
            <div
              v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseServicesRegistered'"
              class="collapse collapseServicesRegistered col-xs-12 col-md-12 col-lg-12 p-0"
              :class="{ in: selection[keyValue], 'item-divider': includeDeactivatedAccounts }"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 pr-0 date-range">
                <ul class="pl-0 mt-6">
                  <li
                    class="col-xs-12 p-0"
                    v-for="(service, index) in servicesList"
                    :key="index"
                    @click="selectService(service.name)"
                  >
                    <div
                      class="col-xs-10 pl-0 sub-approval"
                      :class="{
                        'font-bold': filterOptions.servicesRegistered.indexOf(service.name) > -1
                      }"
                    >
                      {{ service.name }}
                    </div>
                    <a
                      class="col-xs-2 p-0 text-right"
                      v-if="filterOptions.servicesRegistered.indexOf(service.name) > -1"
                    >
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Service Expiration will end here -->
            <!-- Account status/User Status will start here -->
            <div
              v-if="
                (`collapse${value.replaceAll(' ', '')}` === 'collapseAccountStatus' &&
                  includeDeactivatedAccounts) ||
                (`collapse${value.replaceAll(' ', '')}` === 'collapseUserStatus' &&
                  includeDeactivatedUsers)
              "
              class="collapse col-xs-12 col-md-12 col-lg-12 p-0"
              :class="{
                in: selection[keyValue],
                collapseAccountStatus: includeDeactivatedAccounts,
                collapseUserStatus: includeDeactivatedUsers
              }"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 date-range pr-0">
                <ul class="pl-0 mt-6">
                  <li
                    class="col-xs-12 p-0"
                    @click="onAccountTypeOrStatusSelection('active', mappedValues[value])"
                  >
                    <div
                      class="col-xs-10 pl-0 sub-approval"
                      :class="{ 'font-bold': filterOptions[mappedValues[value]] === 'active' }"
                    >
                      Active
                    </div>
                    <a
                      class="col-xs-2 p-0 text-right"
                      v-if="filterOptions[mappedValues[value]] === 'active'"
                    >
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onAccountTypeOrStatusSelection('deactivated', mappedValues[value])"
                  >
                    <div
                      class="col-xs-10 pl-0 sub-approval"
                      :class="{ 'font-bold': filterOptions[mappedValues[value]] === 'deactivated' }"
                    >
                      Deactivated
                    </div>
                    <a
                      class="col-xs-2 p-0 text-right"
                      v-if="filterOptions[mappedValues[value]] === 'deactivated'"
                    >
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Account status/User Status will end here -->
            <!-- Categories will start here -->
            <div
              v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseCategory'"
              class="collapse collapseCategory col-xs-12 col-md-12 col-lg-12 mt-10 p-0"
              :class="{ in: selection[keyValue] }"
            >
              <div class="form-group">
                <base-tooltip
                  :content="tooltips.category"
                  placement="top"
                  :disabled="!filterOptions.categories"
                  popper-class="br-10 w-250 custom-doc-el-select"
                >
                  <multiselect
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="multiselect-single-dropdown"
                    open-direction="bottom"
                    :searchable="false"
                    :options="availableCategoriesList.map((category) => category.id)"
                    :custom-label="
                      (option) => availableCategoriesList.find((x) => x.id === option).name
                    "
                    v-model="filterOptions.categories"
                    @input="setSubCategoriesList(filterOptions.categories)"
                    placeholder="Select Category"
                  >
                  </multiselect>
                </base-tooltip>
              </div>
            </div>
            <!-- Categories will end here -->
            <!-- Sub Categories will start here -->
            <div
              v-if="
                filterOptions.categories &&
                `collapse${value.replaceAll(' ', '')}` === 'collapseSubCategory'
              "
              class="collapse collapseSubCategory col-xs-12 col-md-12 p-0 col-lg-12 mt-10"
              :class="{ in: selection[keyValue] }"
            >
              <div class="col-xs-12 p-0">
                <div class="form-group">
                  <base-tooltip
                    :content="tooltips.subCategory"
                    placement="top"
                    :disabled="!filterOptions.subCategories"
                    popper-class="w-250"
                  >
                    <multiselect
                      :showLabels="false"
                      :close-on-select="true"
                      :allow-empty="false"
                      class="multiselect-single-dropdown"
                      open-direction="bottom"
                      :searchable="false"
                      :options="availableSubCategoriesList.map((subCategory) => subCategory.id)"
                      :custom-label="
                        (option) => availableSubCategoriesList.find((x) => x.id === option).name
                      "
                      v-model="filterOptions.subCategories"
                      @input="setTooltipForSubcategories(filterOptions.subCategories)"
                      placeholder="Select Sub-category"
                    >
                    </multiselect>
                  </base-tooltip>
                </div>
              </div>
            </div>
            <!-- Sub categories will end here -->
            <!-- Countries will start here -->
            <div
              v-if="
                `collapse${value.replaceAll(' ', '')}` === 'collapseCountry' &&
                keyValue === 'isCountryChevron'
              "
              class="collapse collapseCountry col-xs-12 col-md-12 col-lg-12 mt-10 multiple-select-zindex p-0"
              :class="{ in: selection[keyValue] }"
            >
              <div class="col-xs-12 countries-list">
                <div class="col-xs-12 p-0 search-container-wraper">
                  <div class="search-container col-xs-12 p-0">
                    <search-box v-model="countryName" @getList="filterCountriesList()"></search-box>
                  </div>
                </div>
                <div
                  class="col-xs-12 p-0 pt-10 element-scroll-bar"
                  v-if="availableCountriesList.length"
                >
                  <ul v-on:click.stop class="row m-0">
                    <li
                      class="col-xs-12"
                      v-for="country in availableCountriesList"
                      :key="isCountryString ? country : country[types.countryId]"
                    >
                      <span class="checkbox inline-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            :value="isCountryString ? country : country[types.countryId]"
                            v-model="selectedCountryIdList"
                            @change="setFilteredCountriesList"
                          />
                          <span class="cr"> </span>
                        </label>
                      </span>
                      <span
                        class="countries"
                        :class="{
                          'active-country':
                            selectedCountryIdList.indexOf(
                              isCountryString ? country : country[types.countryId]
                            ) > -1
                        }"
                        >{{ isCountryString ? country : country[types.countryName] }}</span
                      >
                    </li>
                  </ul>
                </div>
                <div v-else class="col-xs-12 text-center font-16 mt-10">No countries found.</div>
              </div>
              <!-- <div v-else>
                <multiselect
                  class="multiselect-single-dropdown"
                  :show-labels="false"
                  :allow-empty="false"
                  :searchable="true"
                  placeholder="Select Country"
                  v-model="selectedCountryIdList"
                  @select="setSelectedCountry($event)"
                  :options="availableCountriesList"
                ></multiselect>
              </div> -->
              <!-- Add single select country -->
            </div>
            <!-- Countries will end here -->
            <!-- Countries list with multi select start here -->
            <div
              v-if="
                `collapse${value.replaceAll(' ', '')}` === 'collapseCountry' &&
                keyValue === 'isMultiSelectCountryChevron'
              "
              class="collapse collapseCountry col-xs-12 col-md-12 col-lg-12 mt-10 multiple-select-zindex"
              :class="{ in: selection[keyValue] }"
            >
              <multiselect
                :showLabels="false"
                :close-on-select="false"
                class="multiselect-single-dropdown multiselect-multiple rectangular-border"
                placeholder="Country"
                label="country_code"
                track-by="id"
                :multiple="true"
                :searchable="true"
                :clear-on-select="false"
                :options="countriesList"
                :value="selectedCountryIdList"
              >
                <div class="selection-count" slot="selection" slot-scope="{ values, isOpen }">
                  <template v-if="!isOpen && values.length == countriesList.length">
                    <img
                      src="/static/images/icons/filter.svg"
                      alt="filter-icon"
                      class="image-size"
                    /><span class="selected-count">All</span>
                  </template>
                  <template v-else-if="!isOpen">
                    <img
                      src="/static/images/icons/filter.svg"
                      alt="filter-icon"
                      class="image-size"
                    /><span class="selected-count">{{ values.length }} Selected</span>
                  </template>
                  <template v-else-if="isOpen">
                    <img
                      src="/static/images/icons/filter.svg"
                      alt="filter-icon"
                      class="image-size"
                    />
                  </template>
                </div>
                <span slot="option" slot-scope="props">
                  <div class="d-flex" @input="toggleCBValue(props.option)">
                    <span class="checkbox inline-checkbox">
                      <label>
                        <input
                          type="checkbox"
                          :value="props.option.productName"
                          :checked="props.option.selected"
                        />
                        <span class="cr"> </span>
                      </label>
                    </span>
                    <div @click="toggleCBValue(props.option)">
                      {{ props.option.country_name }}
                    </div>
                  </div>
                </span>
                <span slot="noResult">No matching data</span>
              </multiselect>
            </div>
            <!-- Countries list with multi select end here -->
            <!-- Effective date will start here -->
            <div
              v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseEffectiveDate'"
              class="collapse collapseEffectiveDate col-xs-12 col-md-12 col-lg-12 mt-10 p-0"
              :class="{ in: selection[keyValue] }"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 p-0 date-range">
                <div class="col-xs-12 col-md-12 col-lg-12 date-range">
                  <ul class="pl-0 mt-6">
                    <li
                      class="col-xs-12 p-0"
                      @click="onDocumentDaysSelection('isNext30Days', 'effectiveDates')"
                      v-if="
                        (types.label === 'regWatch' &&
                          permissions.includes('REG_WTCH_REG_UPD_NEXT_30_DAYS')) ||
                        types.label !== 'regWatch'
                      "
                    >
                      <div
                        class="col-xs-10 pl-0 sub-approval"
                        :class="{ 'font-bold': totalDates.effectiveDates.isNext30Days }"
                      >
                        Next 30 Days
                      </div>
                      <a
                        class="col-xs-2 p-0 text-right"
                        v-if="totalDates.effectiveDates.isNext30Days"
                      >
                        <img
                          src="/static/images/icons/check.svg"
                          class="image-size"
                          alt="check-icon"
                        />
                      </a>
                    </li>
                    <li
                      class="col-xs-12 p-0"
                      @click="onDocumentDaysSelection('isNext6Months', 'effectiveDates')"
                      v-if="
                        (types.label === 'regWatch' &&
                          permissions.includes('REG_WTCH_REG_UPD_NEXT_6_MONTHS')) ||
                        types.label !== 'regWatch'
                      "
                    >
                      <div
                        class="col-xs-10 pl-0 sub-approval"
                        :class="{ 'font-bold': totalDates.effectiveDates.isNext6Months }"
                      >
                        Next 6 Months
                      </div>
                      <a
                        class="col-xs-2 p-0 text-right"
                        v-if="totalDates.effectiveDates.isNext6Months"
                      >
                        <img
                          src="/static/images/icons/check.svg"
                          class="image-size"
                          alt="check-icon"
                        />
                      </a>
                    </li>
                    <li
                      class="col-xs-12 p-0"
                      @click="onDocumentDaysSelection('isThisYear', 'effectiveDates')"
                      v-if="
                        (types.label === 'regWatch' && permissions.includes('THIS_YEAR')) ||
                        types.label !== 'regWatch'
                      "
                    >
                      <div
                        class="col-xs-10 pl-0 sub-approval"
                        :class="{ 'font-bold': totalDates.effectiveDates.isThisYear }"
                      >
                        This Year
                      </div>
                      <a
                        class="col-xs-2 p-0 text-right"
                        v-if="totalDates.effectiveDates.isThisYear"
                      >
                        <img
                          src="/static/images/icons/check.svg"
                          class="image-size"
                          alt="check-icon"
                        />
                      </a>
                    </li>
                    <li
                      class="col-xs-12 p-0"
                      @click="onDocumentDaysSelection('isNextYear', 'effectiveDates')"
                      v-if="
                        (types.label === 'regWatch' &&
                          permissions.includes('REG_WTCH_REG_UPD_NEXT_YEAR')) ||
                        types.label !== 'regWatch'
                      "
                    >
                      <div
                        class="col-xs-10 pl-0 sub-approval"
                        :class="{ 'font-bold': totalDates.effectiveDates.isNextYear }"
                      >
                        Next Year
                      </div>
                      <a
                        class="col-xs-2 p-0 text-right"
                        v-if="totalDates.effectiveDates.isNextYear"
                      >
                        <img
                          src="/static/images/icons/check.svg"
                          class="image-size"
                          alt="check-icon"
                        />
                      </a>
                    </li>
                  </ul>
                  <filter-date
                    v-if="
                      (types.label === 'regWatch' &&
                        permissions.includes('REG_WTCH_REG_UPD_EFF_DATE_RANGE')) ||
                      types.label !== 'regWatch'
                    "
                    :eventType="'effectiveDates'"
                    @dateRange="setCustomDateRange($event, value, 'effectiveDates')"
                    :label="types.label"
                    :dateFormat="dateFormat"
                  >
                  </filter-date>
                </div>
              </div>
            </div>
            <div
              v-if="`collapse${value.replaceAll(' ', '')}` === 'collapseExpirationDate'"
              class="collapse collapseExpirationDate col-xs-12 col-md-12 col-lg-12 mt-10 p-0"
              :class="{ in: selection[keyValue] }"
            >
              <div class="col-xs-12 col-md-12 col-lg-12 p-0 date-range">
                <ul class="pl-0 mt-6">
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isThisMonth', 'expirationDates')"
                  >
                    <div
                      class="col-xs-10 pl-0 sub-approval"
                      :class="{ 'font-bold': totalDates.expirationDates.isThisMonth }"
                    >
                      This month
                    </div>
                    <a
                      class="col-xs-2 p-0 text-right"
                      v-if="totalDates.expirationDates.isThisMonth"
                    >
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isNext3Months', 'expirationDates')"
                  >
                    <div
                      class="col-xs-10 pl-0 sub-approval"
                      :class="{ 'font-bold': totalDates.expirationDates.isNext3Months }"
                    >
                      Next 3 months
                    </div>
                    <a
                      class="col-xs-2 p-0 text-right"
                      v-if="totalDates.expirationDates.isNext3Months"
                    >
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                  <li
                    class="col-xs-12 p-0"
                    @click="onDocumentDaysSelection('isThisYear', 'expirationDates')"
                  >
                    <div
                      class="col-xs-10 pl-0 sub-approval"
                      :class="{ 'font-bold': totalDates.expirationDates.isThisYear }"
                    >
                      Within this year
                    </div>
                    <a class="col-xs-2 p-0 text-right" v-if="totalDates.expirationDates.isThisYear">
                      <img src="/static/images/icons/check.svg" class="image-size" />
                    </a>
                  </li>
                </ul>
                <filter-date
                  :eventType="'expirationDates'"
                  @dateRange="setCustomDateRange($event, value, 'expirationDates')"
                  :label="types.label"
                  :dateFormat="dateFormat"
                >
                </filter-date>
              </div>
            </div>
            <!-- Effective date will end here -->
          </div>
        </div>
        <div
          v-if="
            (types.label === 'records' && permissions.includes('CLEAR_ALL')) ||
            types.label !== 'records'
          "
          class="col-xs-12 text-right clear-option cursor-pointer pr-0"
          :class="{ 'cursor-pointer-disable': !showFilterIcon }"
        >
          <a @click.prevent="clearAll()" :disabled="!showFilterIcon">Clear All</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { cloneDeep, isEqual } from 'lodash';
import moment from 'moment';
import getDateRange from './mixins/dateRangeSelectionMixin';
import FilterDate from './FilterDate.vue';
import SearchBox from './SearchBox.vue';
import EventBus from '../../utils/event-bus';
import BaseTooltip from '../Common/BaseTooltip.vue';

export default {
  // props: [
  //   'chevronList',
  //   'expectedFilter',
  //   'dateFormat',
  //   'categoriesList',
  //   'subCategoriesList',
  //   'countriesList',
  //   'types',
  //   'permissions',
  // ],

  props: {
    hideServicesForGlobalSearch: {
      type: Boolean,
      default: false
    },
    isCountryString: {
      type: Boolean,
      default: false
    },
    chevronList: {
      type: Object
    },
    expectedFilter: {
      type: Object
    },
    dateFormat: {
      type: String
    },
    categoriesList: {
      type: Array,
      default() {
        return [];
      }
    },
    subCategoriesList: {
      type: Array,
      default() {
        return [];
      }
    },
    countriesList: {
      type: Array,
      default() {
        return [];
      }
    },
    types: {
      type: Object
    },
    permissions: {
      type: Array,
      default() {
        return [];
      }
    },
    servicesList: {
      type: Array,
      default() {
        return [];
      }
    },
    includeDeactivatedAccounts: {
      type: Boolean,
      default: false
    },
    includeDeactivatedUsers: {
      type: Boolean,
      default: false
    },
    isRegWatch: {
      type: Boolean,
      default: false
    },
    isCompact: {
      type: Boolean,
      default: false
    }
  },

  mixins: [getDateRange],
  components: {
    FilterDate,
    SearchBox,
    BaseTooltip
  },
  data() {
    return {
      totalDates: {
        commonDates: {
          isLast7Days: false,
          isLast30Days: false,
          isLastYear: false
        },
        effectiveDates: {
          isNext30Days: false,
          isNext6Months: false,
          isThisYear: false,
          isNextYear: false
        },
        expirationDates: {
          isThisMonth: false,
          isNext3Months: false,
          isThisYear: false
        },
        serviceExpDates: {
          isExpiringIn30Days: false,
          isExpiringIn30To45Days: false
        }
      },
      countryName: '',
      mappedValues: {
        'Document Date': 'dateRange',
        Date: 'dateRange',
        'Date Created': 'dateRange',
        Category: 'categories',
        'Sub Category': 'subCategories',
        'Posted Date': 'dateRange',
        'Effective Date': 'effectiveDates',
        'Expiration Date': 'expirationDates',
        'Approval Date': 'dateRange',
        'Account Type': 'accountType',
        'Service Expiration': 'serviceExpDates',
        'Services Registered': 'servicesRegistered',
        'Account Status': 'accountStatus',
        'User Status': 'userStatus',
        'Confirm Status': 'confirmedType',
        'Date Signed': 'signedDates'
      },
      start_approval_date: '',
      end_approval_date: '',
      // isDateRangeSelected: false,
      // showFilterIcon: false,
      collapsed: true,
      availableCategoriesList: [],
      categoryListWithIdAndNames: {},
      availableSubCategoriesList: [],
      subCategoryListWithIdAndNames: {},
      availableCountriesList: [],
      selection: {},
      filterOptions: {},
      selectedCountryIdList: [],
      tooltips: {
        category: '',
        subCategory: '',
        service: ''
      }
    };
  },
  watch: {
    chevronList: {
      handler(value) {
        Object.keys(value).forEach((key) => {
          this.selection[key] = false;
        });
      },
      immediate: true
    },
    expectedFilter: {
      handler(newValue) {
        this.filterOptions = cloneDeep(newValue);
      },
      immediate: true
    },
    categoriesList: {
      handler(newValue) {
        if (newValue) {
          this.availableCategoriesList = cloneDeep(this.categoriesList);
          this.categoryListWithIdAndNames = this.getListOfIdsWithNames(this.categoriesList);
        }
      },
      immediate: true
    },
    subCategoriesList: {
      handler(newValue) {
        if (newValue) {
          this.subCategoryListWithIdAndNames = this.getListOfIdsWithNames(this.subCategoriesList);
        }
      },
      immediate: true
    },
    countriesList: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue.length < oldValue?.length && this.types.label === 'regWatch') {
            this.setSelectedCountriesWithUpdatedList(newValue);
          }
          this.availableCountriesList = cloneDeep(this.countriesList);
          // if (this.types.label === 'global_search') this.selectedCountryIdList = [];
        }
      },
      immediate: true
    },
    $route(to) {
      if (to.name === 'SearchResults') {
        this.selectedCountryIdList = [];
      }
    },
    includeDeactivatedAccounts: {
      handler(newValue) {
        if (!newValue && this.filterOptions.accountStatus) {
          this.filterOptions.accountStatus = '';
          this.checkIsFilterValuesManuallyCleared();
        }
      }
    },
    includeDeactivatedUsers: {
      handler(newValue) {
        if (!newValue && this.filterOptions.userStatus) {
          this.filterOptions.userStatus = '';
          this.checkIsFilterValuesManuallyCleared();
        }
      }
    }
  },
  computed: {
    showFilterIcon() {
      return !isEqual(this.expectedFilter, this.filterOptions);
    }
  },

  mounted() {
    EventBus.$on('redirectionParams', (params) => {
      if (this.types.label === 'regWatch' || this.types.label === 'marketInsights') {
        if (
          (this.types.label === 'regWatch' &&
            this.countriesList.some((list) => list.id === params.countryId)) ||
          this.types.label === 'marketInsights'
        ) {
          this.selectedCountryIdList = [params.countryId];
        }
        if (params.startDate && params.endDate) {
          this.filterOptions.dateRange.from = moment(params.startDate).format(this.dateFormat);
          this.filterOptions.dateRange.to = moment(params.endDate).format(this.dateFormat);
          EventBus.$emit('setCustomDatesForcommonDates', {
            startDate: params.startDate,
            endDate: params.endDate
          });
        }
        this.setFilteredCountriesList();
      } else if (['launchpadAccounts', 'launchpadUsers'].includes(this.types.label)) {
        this.filterOptions.accountType = params.account_type;
        if (this.types.label === 'launchpadAccounts') {
          this.filterOptions.servicesRegistered = params.services_registered
            ? [params.services_registered]
            : [];
        }
        if (params.service_expiry === 'expiring30Days') {
          this.onDocumentDaysSelection('isExpiringIn30Days', 'serviceExpDates');
        } else if (params.service_expiry === 'expiring30To45Days') {
          this.onDocumentDaysSelection('isExpiringIn30To45Days', 'serviceExpDates');
        }
        this.emitFilterOptions();
      }
    });
  },

  beforeDestroy() {
    EventBus.$off('redirectionParams');
    EventBus.$off('filterCountriesList');
  },

  methods: {
    setSelectedCountriesWithUpdatedList(list) {
      if (this.selectedCountryIdList.length) {
        const listWithIds = list.reduce((acc, value) => {
          acc[value[this.types.countryId]] = true;
          return acc;
        }, {});
        this.selectedCountryIdList = this.selectedCountryIdList.filter(
          (countryId) => listWithIds[countryId]
        );
        this.setFilteredCountriesList();
      }
    },
    setSelectedCountry(value) {
      this.filterOptions.countriesList = [value];
      this.emitFilterOptions();
    },
    toggleCBValue(option) {
      for (let i = 0; i < this.countriesList.length; i += 1) {
        if (this.countriesList[i].country_code === option.country_code) {
          this.countriesList[i].selected = !this.countriesList[i].selected;
          break;
        }
      }
      this.selectedCountryIdList = cloneDeep(
        this.countriesList.filter((country) => country.selected).map((c) => c.id)
      );
      this.filterOptions.countriesList = cloneDeep(
        this.countriesList.filter((country) => country.selected).map((c) => c.id)
      );
      this.emitFilterOptions();
    },
    setCustomDateRange(value, key, dateCategory) {
      const filterKey = this.mappedValues[key];
      this.filterOptions[filterKey] = value;
      this.setDaysSelected('', dateCategory);
      this.emitFilterOptions();
    },

    onAccountTypeOrStatusSelection(value, key) {
      if (this.filterOptions[key] === value) this.filterOptions[key] = '';
      else this.filterOptions[key] = value;
      this.emitFilterOptions();
    },

    selectService(service) {
      const index = this.filterOptions.servicesRegistered.indexOf(service);
      if (index > -1) this.filterOptions.servicesRegistered.splice(index, 1);
      else this.filterOptions.servicesRegistered.push(service);
      this.emitFilterOptions();
    },

    filterWithType(type) {
      if (type === 'attachment') {
        this.filterOptions.attachment = !this.filterOptions.attachment;
      } else this.filterOptions.regulatoryAlert = !this.filterOptions.regulatoryAlert;
      this.emitFilterOptions();
    },

    setSubCategoriesList(categoryId) {
      this.filterOptions.subCategories = '';
      this.tooltips = {
        ...this.tooltips,
        category: this.categoryListWithIdAndNames[categoryId]
      };
      this.availableSubCategoriesList = this.subCategoriesList.filter(
        (sub) => sub.category_id === categoryId
      );
      this.emitFilterOptions();
    },
    setTooltipForSubcategories(categoryId) {
      this.tooltips = {
        ...this.tooltips,
        subCategory: this.subCategoryListWithIdAndNames[categoryId]
      };
      this.emitFilterOptions();
    },

    getListOfIdsWithNames(target) {
      return target.reduce((acc, category) => {
        acc[category.id] = category.name;
        return acc;
      }, {});
    },

    onDocumentDaysSelection(daysSelected, dateCategory) {
      this.setDaysSelected(daysSelected, dateCategory);
      if (this.totalDates[dateCategory][daysSelected]) {
        EventBus.$emit(`normalDatesSelected${dateCategory}`);
        this.getStartTimeAndEndTime(daysSelected, dateCategory);
      } else {
        const filterKey = dateCategory === 'commonDates' ? 'dateRange' : dateCategory;
        this.clearDateRangeInFilter(filterKey);
      }
    },

    clearDateRangeInFilter(field) {
      this.filterOptions[field] = {};
      this.emitFilterOptions();
    },

    getStartTimeAndEndTime(daysSelected, dateCategory) {
      const key = dateCategory === 'commonDates' ? 'dateRange' : dateCategory;
      const dateRange = this.getDateRange(daysSelected, this.dateFormat, this.types.label);
      this.filterOptions[key].from = dateRange.startDate;
      this.filterOptions[key].to = dateRange.endDate;
      this.emitFilterOptions();
    },

    clearDateRange() {
      this.start_approval_date = '';
      this.end_approval_date = '';
    },

    setDaysSelected(daysSelected = '', dateCategory) {
      Object.keys(this.totalDates[dateCategory]).forEach((key) => {
        if (daysSelected) {
          this.totalDates[dateCategory][key] =
            key === daysSelected ? !this.totalDates[dateCategory][key] : false;
        } else this.totalDates[dateCategory][key] = false;
      });
    },

    toggleSelection(filterCSS, flag) {
      this.selection = { ...this.selection, [flag]: !this.selection[flag] };
      // this.filterOptions.categories = 'test';
      if ($(`.${filterCSS}`).hasClass('in')) {
        $(`.${filterCSS}`).removeClass('in');
      } else {
        $(`.${filterCSS}`).addClass('in');
      }
    },

    showHideFilter(isExpanded = false) {
      this.collapsed = !this.collapsed;
      if (!isExpanded) {
        Object.keys(this.chevronList).forEach((key) => {
          const resultKey = this.mappedValues[this.chevronList[key]];
          if (
            [
              'isDateChevron',
              'isEffectiveDateChevron',
              'isExpiryDateChevron',
              'isServiceExpChevron'
            ].includes(key)
          )
            this.selection[key] = !!(
              this.filterOptions[resultKey].from && this.filterOptions[resultKey].to
            );
          else if (key === 'isCategoryChevron')
            this.selection[key] = !!this.filterOptions[resultKey];
          else if (key === 'isSubCategoryChevron')
            this.selection[key] = !!this.filterOptions[resultKey];
          else if (key === 'isCountryChevron')
            this.selection[key] = !!this.selectedCountryIdList.length;
          else if (this.types.label === 'launchpadAccounts') {
            if (key === 'isAccountTypeChevron')
              this.selection[key] = !!this.filterOptions[resultKey];
            else if (key === 'isServicesChevron')
              this.selection[key] = !!this.filterOptions[resultKey].length;
            else if (key === 'isAccountStatusChevron')
              this.selection[key] = !!this.filterOptions[resultKey];
          } else if (this.types.label === 'launchpadUsers') {
            if (key === 'isAccountTypeChevron')
              this.selection[key] = !!this.filterOptions[resultKey];
            else if (key === 'isUserStatusChevron')
              this.selection[key] = !!this.filterOptions[resultKey];
            else if (key === 'isConfirmChevron')
              this.selection[key] = !!this.filterOptions[resultKey];
          }
        });
        /* Remove country name if present when no country selected */
        if (!this.selection.isCountryChevron && this.countryName) {
          this.availableCountriesList = cloneDeep(this.countriesList);
          this.countryName = '';
        }
      }
    },

    /* Market Insights countries selcetion */
    filterCountriesList() {
      const searchWord = this.countryName.toLowerCase();
      this.availableCountriesList = this.countriesList.filter((country) =>
        country[this.types.countryName].toLowerCase().includes(searchWord)
      );
    },

    setFilteredCountriesList() {
      this.filterOptions.countriesList = cloneDeep(this.selectedCountryIdList);
      this.emitFilterOptions();
    },

    setAllChevrons() {
      Object.keys(this.selection).forEach((key) => {
        this.selection[key] = false;
      });
    },

    clearAll() {
      EventBus.$emit('clearAllCustomDates');
      this.countryName = '';
      this.availableCountriesList = cloneDeep(this.countriesList);
      this.setAllChevrons();
      this.setDefaultValuesToAllDates();
      this.selectedCountryIdList = [];
      if (!isEqual(this.expectedFilter, this.filterOptions)) {
        this.filterOptions = cloneDeep(this.expectedFilter);
        this.emitFilterOptions(false);
      }
    },

    setDefaultValuesToAllDates() {
      this.totalDates = {
        commonDates: {
          isLast7Days: false,
          isLast30Days: false,
          isLastYear: false
        },
        effectiveDates: {
          isNext30Days: false,
          isNext6Months: false,
          isThisYear: false,
          isNextYear: false
        },
        expirationDates: {
          isThisMonth: false,
          isNext3Months: false,
          isThisYear: false
        },
        serviceExpDates: {
          isExpiringIn30Days: false,
          isExpiringIn30To45Days: false
        }
      };
    },

    checkIsFilterValuesManuallyCleared() {
      const ref = cloneDeep(this.expectedFilter);
      const refForFilter = cloneDeep(this.filterOptions);
      delete ref.isFilterSelected;
      delete refForFilter.isFilterSelected;
      this.filterOptions.isFilterSelected = !isEqual(ref, refForFilter);
    },

    emitFilterOptions(clearAll = true) {
      this.filterOptions.isFilterSelected = clearAll;
      this.$emit('setFilter', this.filterOptions);
      if (clearAll) {
        this.checkIsFilterValuesManuallyCleared();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.reg-filter {
  position: absolute;
  z-index: 3;
  left: 15px !important;
  top: 2px;
  margin-left: -20px;
  &.reg-watch {
    top: 0px;
  }
}
.mt-7 {
  margin-top: 7px;
}
.filter-icon {
  padding-right: 8px;
}
#activityFilter {
  height: 52px;
  width: 65px;
  margin-top: 1px;
  &.compact {
    width: 54px !important;
  }
}
.reg-dropdown {
  height: 46px;
  padding: 9px;
  background: $deep-white;
  -webkit-box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);
  box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);
  border-radius: $radius0 4px 4px $radius0;
  &.reg-watch {
    height: 56px;
    width: 72px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    width: 72px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.pl-6 {
  padding-left: 6px;
}
.filter-ul {
  padding: 16px 16px 16px 24px;
  width: 375px;
  display: block;
  background: $deep-white;
}
.filter-wrapper {
  padding-right: 7px;
  overflow: auto;
  height: 480px;
}
.dropdown-menu-left {
  right: auto;
  left: 0px;
  top: -4px;
  margin: 6px 0 0;
}
.item-divider {
  border-bottom: 1px solid #d3d6d9;
  padding-bottom: 7px;
  margin-top: 6px;
}
.collapseDocumentDate {
  &.in {
    border-bottom: 1px solid #d3d6d9;
    padding-bottom: 10px;
  }
}
.mt-6 {
  margin-top: 6px;
}
.pt-3 {
  padding-top: 3px;
}
.font-properties {
  @include fontItems($font-16, 19px, $font-weight-medium);
  color: $primary;
}
.sub-approval {
  color: $primary;
  font-size: $font-16;
  line-height: 19px;
  margin-bottom: 13px;
}
.clear-option {
  a {
    @include fontItems($font-14, 16px, $font-weight-medium);
    color: $primary;
  }
}
.countries-list ul,
.date-range ul {
  list-style-type: none;
  padding: 0;
  z-index: 1;
  border-radius: $radius10;
  border: none;
  max-height: 200px;
}
.countries-list {
  box-sizing: border-box;
  height: 250px;
  padding: 16px 5px 16px 16px;
  ul {
    li {
      color: $dark-black-alpha;
      padding: 5px 5px 8px 0px;
      font-size: $font-16;
    }
  }
}
.count {
  position: absolute;
  left: 27px;
  top: 5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  line-height: 16px;
  font-size: $font-10;
  text-align: center;
  cursor: pointer;
  color: $white;
  background: $light-green;
}
.reg-watch {
  .count {
    left: 40%;
    top: 22%;
    left: 40%;
    top: 22%;
  }
  .dropdown-menu-left {
    top: -6px;
  }
}
.image-size {
  width: 18px;
  height: 18px;
}
.filter-text {
  display: inline-flex;
  padding-bottom: 18px;
}
.pr-2 {
  padding-right: 2px;
}
.search-container-wraper {
  padding-right: 11px;
}
.start-to-end {
  font-size: $font-12;
  line-height: 14px;
  color: $dark-black-alpha;
  padding: 5px 8px;
  display: inline;
}
.search-box {
  padding: 17px 72px 17px 20px;
}
.vertical-line {
  top: 7px;
  right: 35px;
  position: absolute;
  border-left: 1px solid #dfe1e5;
  height: 65%;
}
.search-icon {
  top: 7px;
  position: absolute;
  right: 10px;
}
.active-country {
  font-weight: 700;
}
.countries {
  font-size: $font-16;
  line-height: 23px;
  color: $primary;
}
.chevron-image {
  width: 12px;
  height: 6px;
}
.left-transform {
  transform: rotate(-180deg);
}
.transform-img {
  transform: rotate(180deg);
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
.hide-field {
  display: none;
}
::v-deep .element-scroll-bar {
  overflow-y: scroll;
  margin-top: 10px;
  height: 190px;
  .el-scrollbar__wrap {
    overflow: auto;
    margin-right: -23px !important;
    margin-bottom: -4px !important;
  }
  .el-scrollbar__bar {
    &.is-horizontal {
      display: none;
    }
  }
}
.cursor-pointer-disable {
  cursor: not-allowed;
}
</style>
